<template>
    <users v-slot="{ users, meta: { pagination } = {} }" :params="params">
        <div class="users">
            <div class="leading">
                <button class="btn btn-primary" id="show-modal" @click="editUser()">Add User</button>
            </div>

            <div class="row">
                <div class="col-sm">
                    <div class="form-group mb-sm-0">
                        <label>User Type</label>
                        <select class="form-control" v-model="params.role">
                            <option value="">All</option>
                            <option v-for="role in validRoles" :value="role" :key="role" v-text="role"></option>
                        </select>
                    </div>
                </div>
                <div class="col-sm">
                    <div class="form-group mb-sm-0">
                        <label>Keyword</label>
                        <input class="form-control" type="text" v-model="params.keyword">
                    </div>
                </div>
            </div>

            <div v-if="pagination" class="meta header" v-text="filterSummary(pagination)"></div>

            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>


            <div class="table-responsive">
                <table class="table table-striped">
                    <thead class="manager-list-heading">
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Role</th>
                            <th class="actions">Actions</th>
                        </tr>
                    </thead>
                    <tbody class="manager-list-row">
                        <tr v-for="user in users" :key="user.id">
                            <td class="name" v-text="user.name"></td>
                            <td class="email" v-text="user.email"></td>
                            <td class="phone" v-text="user.phone"></td>
                            <td class="role" v-text="user.role"></td>
                            <td class="actions">
                                <button class="btn btn-primary btn-sm" @click="editUser(user.id)">Edit</button>
                                <a class="btn btn-primary btn-sm" :href="showDetailLink(user.id)">View Detail</a>
                                <form :action="`become-user/${user.id}`" method="get">
                                    <button class="btn btn-primary btn-sm" type="submit">Log in as…</button>
                                </form>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="footer">
                <pagination
                    v-if="pagination"
                    v-model="params.page"
                    :total-pages="pagination.last_page"
                    :value="pagination.current_page"
                >
                </pagination>
            </div>

            <user-modal v-if="showModal" @refresh="filterSummary(pagination)" @close="showModal = false;" :id="modalUser"></user-modal>

            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
        </div>
    </users>
</template>
<script>
import Filtering from './helpers/Filtering';
import UserModal from './UserModal';
import ModalWatcher from './ModalWatcher';
import { PaginatedCollectionComponent, PaginationNav } from 'clockvine-vue';

export default {
    components: {
        UserModal,
        pagination: PaginationNav,
        users: PaginatedCollectionComponent.for("users")
    },

    mixins: [
        Filtering, 
        ModalWatcher
    ],

    data: () => ({
        showModal: false,
        modalUser: null,
        validRoles: [
            'Administrator',
            'Dealer',
            'Customer'
        ],
        errorMessage: '',
        params: {
            role: '',
            keyword: '',
            page: 1,
        }
    }),

    methods: {
        editUser(id) {
            this.modalUser = id;
            this.showModal = true;
        },

        showDetailLink(id) {
            return './users/' + id;
        },
    },
}
</script>
